import {
  SearchOutlined,
  DeleteOutlined,
  ReloadOutlined,
  ImportOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import { Button } from "antd";

const FilterAction = ({
  search,
  reset,
  excel,
  deletes,
  loadingExcel,
  importData,
}: any) => {
  return (
    <>
      {search && (
        <Button
          onClick={search}
          type="primary"
          style={{ marginRight: "10px", backgroundColor: "#0d5ace" }}
        >
          <div className="content-btn">
            <span className="name">
              <SearchOutlined /> Tìm kiếm
            </span>
          </div>
        </Button>
      )}
      {excel && (
        <Button
          className="heading-button-export-excel"
          icon={<FileExcelOutlined />}
          loading={loadingExcel}
          onClick={excel}
        >
          Xuất excel
        </Button>
      )}
      {deletes && (
        <Button onClick={deletes} type="dashed" danger>
          <span className="name">
            <DeleteOutlined /> Xóa dữ liệu
          </span>
        </Button>
      )}
      {reset && (
        <Button onClick={reset}>
          <div className="content-btn">
            <span className="name">
              <ReloadOutlined /> Làm mới
            </span>
          </div>
        </Button>
      )}
      {importData && (
        <Button onClick={importData}>
          <div className="content-btn">
            <span className="name">
              <ImportOutlined /> Import dữ liệu
            </span>
          </div>
        </Button>
      )}
    </>
  );
};

export default FilterAction;
